<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">
    <vs-popup
      class="holamundo"
      title="Request Withraw Amount"
      :active.sync="popupActive"
      @cancel="clearFields"
      @close="clearFields"
    >
      <span class="flex justify-end text-green font-bold">Company Wallet: {{company_wallet}}</span>
      <vs-input
        v-validate="'required|numeric|max_value:'+company_wallet"
        label="Amount"
        name="amount"
        v-model="withdraw_amount"
        class="w-full"
      />
      <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>

      <vs-button
        width="100%"
        color="success"
        type="gradient"
        class="mt-4 w-full"
        @click.prevent="submitReq"
      >Request</vs-button>
    </vs-popup>

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>Available</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>-->
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:bg-primary hover:text-white"
            @click="reqWithdraw"
          >
            <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Request Withdrawel</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { _withdraw } from "@/services/Company";
export default {
  data() {
    return {
      popupActive: false,
      withdraw_amount: null,
      company_wallet: null,
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    clearFields() {
      this.withdraw_amount = null;
    },
    reqWithdraw() {
      this.company_wallet = this.$store.state.company.wallet_amount;
      this.popupActive = true;
    },
    submitReq() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          const localData = {
            amount: Number.parseInt(this.withdraw_amount),
          };
          _withdraw(this.$store.state.company.companyID, localData).then((response) => {
              this.$vs.loading.close();
              this.clearFields();
              this.popupActive = false;
              this.$vs.notify({
                title: response.data.responseTitle,
                text: response.data.responseMessage,
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
              });
            }).catch((error) => {
              this.$vs.notify({
                title: error.response.data.responseTitle,
                text: error.response.data.responseMessage,
                iconPack: "feather",
                icon: "icon-cross-circle",
                color: "danger",
              });
            });
        } else {
          // form have errors
        }
      });
    },
    logout() {
      this.$store.dispatch("auth/doLogout").then(() => {
        // if(localStorage.getItem("accessToken")) {
        //   localStorage.removeItem("accessToken")
        //   this.$router.push('/login').catch(() => {})
        // }
        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change("admin");
        localStorage.removeItem("userInfo");

        // This is just for demo Purpose. If user clicks on logout -> redirect
        this.$router.push("/login").catch(() => {});
      });
    },
  },
};
</script>
